import { useState } from "react";

function KnowledgeHub() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const categories = [
    {
      title: "🎓 Training Sessions",
      videos: [
        {
          title: "Building The Future Of Datacenters by Sindhu Ma'am",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/Videos/Sindhu_Mam",
        },
      ],
    },
    {
      title: "🚀 Internal Tools",
      videos: [
        {
          title: "Dashboard Overview",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Dashboard.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/dashboard.mp4",
        },
        {
          title: "LSP AI Assistant",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/ai.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/ai-assistant.mp4",
        },
      ],
    },
    {
      title: "💬 Communication",
      videos: [
        {
          title: "Mattermost Essentials",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/mattermost.mp4",
        },
        {
          title: "Roundcube Mail",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/mail.mp4",
        },
        {
          title: "Thunderbird Setup",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/thunderbird.mp4",
        },
      ],
    },
    {
      title: "📦 Company Systems",
      videos: [
        {
          title: "InvenTree Basics",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/inventree.mp4",
        },
      ],
    },
    {
      title: "☁️ Storage & Files",
      videos: [
        {
          title: "My Cloud Home",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          videoUrl: "https://storage.googleapis.com/lsp-webstore/videos/cloud.mp4",
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-[#F5F7FB]">

      {/* HEADER */}
      <div className="relative overflow-hidden bg-gradient-to-r from-[#0F172A] via-[#111827] to-[#1F2937] text-white px-10 py-14">

        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_right,_#C00000,_transparent_60%)]" />

        <div className="relative z-10">
          <h1 className="text-4xl font-bold tracking-wide">
            Knowledge Hub
          </h1>

          <p className="mt-3 text-gray-300 max-w-2xl">
            Learn the tools, systems, and workflows used across LightSpeed Photonics.
            Structured training designed for fast onboarding and productivity.
          </p>
        </div>
      </div>

      {/* CONTENT */}
      <div className="px-10 py-10 space-y-12">

        {categories.map((category) => (
          <div key={category.title}>

            <h2 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-[#C00000] pl-3">
              {category.title}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">

              {category.videos.map((video) => (
                <div
                  key={video.title}
                  onClick={() => setSelectedVideo(video)}
                  className="
                    group
                    bg-white
                    rounded-2xl
                    overflow-hidden
                    shadow-sm
                    border
                    border-gray-100
                    cursor-pointer
                    hover:shadow-xl
                    hover:-translate-y-1
                    transition-all
                    duration-300
                  "
                >

                  {/* THUMBNAIL */}
                  <div className="relative h-44 overflow-hidden">

                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="
                        w-full
                        h-full
                        object-cover
                        group-hover:scale-110
                        transition-transform
                        duration-500
                      "
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  </div>

                  {/* TEXT */}
                  <div className="p-4">

                    <h3 className="font-semibold text-gray-900 group-hover:text-[#C00000] transition">
                      {video.title}
                    </h3>

                    <p className="text-sm text-gray-500 mt-1">
                      Internal Training Video
                    </p>

                  </div>

                </div>
              ))}

            </div>
          </div>
        ))}
      </div>

      {/* VIDEO MODAL */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">

          <div className="bg-black p-4 rounded-xl w-[85%] max-w-5xl">

            <video
              controls
              autoPlay
              className="w-full rounded-lg"
            >
              <source src={selectedVideo.videoUrl} type="video/mp4" />
              Your browser does not support video playback.
            </video>

            <div className="flex justify-between items-center mt-3 text-white">

              <h3 className="text-sm">{selectedVideo.title}</h3>

              <button
                className="bg-red-600 px-3 py-1 rounded-md text-sm hover:bg-red-700"
                onClick={() => setSelectedVideo(null)}
              >
                Close
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
}

export default KnowledgeHub;